module.exports = __webpack_public_path__ + "images/1f6ab439d76a422510fdced2f69881de.png";